<template>
  <div><p>用户反馈</p></div>
</template>

<script>
  export default {
    name: "feedback"
  }
</script>

<style scoped>

</style>
